import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutQuery } from '../../../layout/state/layout.query';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-change-password-success',
  templateUrl: './change-password-success.component.html',
  styleUrls: ['./change-password-success.component.scss'],
  standalone: false,
})
export class ChangePasswordSuccessComponent implements OnInit {

  constructor(public layoutQuery: LayoutQuery, private router: Router) { }

  ngOnInit() {
  }
  gotoLogin() {
    this.router.navigate([`login`]);
  }
}
